import type { Api } from "api-client";
import { z } from "zod";

export const formSchema = z.object({
  name: z.string(),
  email: z.union([z.literal(""), z.email()]),
  type: z.union([
    z.literal("IN_PERSON"),
    z.literal("ONLINE"),
    z.literal("HYBRID"),
  ]),
});

export type FormSchema = z.infer<typeof formSchema>;

export interface InviteAthleteDialogContentProps {
  closeModal(): void;
  name?: string;
  onInviteSuccess?: (arg: Api.InviteAthlete.Output.Self) => void;
}
